import React from 'react'
import { Flex, Label, Button, Table } from '@fareye/ui'
import { FaDownload, isEmpty, dMmm } from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'

import { getTableColumns } from './Column'
import { tripTabsBackground, modeBackground } from '@fareye/configs'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px'
  }
}

export const Delays = ({ otherData, config }: any) => {
  const { delays = [] } = otherData
  const { t } = useTranslation()
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const {
    config: { delayColumns }
  } = config
  const selectedColumn = React.useMemo(() => {
    return getTableColumns(delayColumns, {
      t,
      queryParams: {}
    })
  }, [])
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Flex justifyContentSpaceBetween>
          <Label
            style={{ fontSize: '16px', fontWeight: 600, marginTop: '6px' }}
          >
            Delays
          </Label>

          <Button
            disabled={false}
            isLoading={downloadLoading}
            variant="s primary"
            style={{ height: '30px' }}
            onClick={() => {
              setDownloadLoading(true)
              downloadToCSV({
                data: delays,
                fileName: `portLogs_${dMmm()}`
              })
              setDownloadLoading(false)
            }}
          >
            Download CSV
            <FaDownload style={style.downloadIcon} />
          </Button>
        </Flex>
      </Flex>
      {!isEmpty(delays) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            totalElements={delays.length}
            sortable={false}
            showTotalCount={false}
            showPagination={false}
            data={delays}
            columns={selectedColumn}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Data
        </Label>
      )}
    </Flex>
  )
}
